export default {
  "create-vehicle-type-success": {
    EN: "Vehicle type created successfully",
  },
  "create-vehicle-type-failure": {
    EN: "Failed to create vehicle type",
  },
  "create-vehicle-success": {
    EN: "Vehicle created successfully",
  },
  "create-vehicle-failure": {
    EN: "Failed to create vehicle",
  },
  "update-work-order-success": {
    EN: "Work order updated successfully",
  },
  "update-work-order-failure": {
    EN: "Failed to update work order",
  },
  "update-work-order-status-success": {
    EN: "Work order status updated successfully",
  },
  "update-work-order-status-failure": {
    EN: "Failed to update work order status",
  },
  "create-inspection-question-success": {
    EN: "Inspection question created successfully",
  },
  "create-inspection-question-failure": {
    EN: "Failed to create inspection question",
  },
  "update-inspection-question-success": {
    EN: "Inspection question updated successfully",
  },
  "update-inspection-question-failure": {
    EN: "Failed to update inspection question",
  },
  "delete-inspection-question-success": {
    EN: "Inspection question deleted successfully",
  },
  "delete-inspection-question-failure": {
    EN: "Failed to delete inspection question",
  },
  "create-work-order-success": {
    EN: "Successfully created work order.",
  },
  "create-work-order-failure": {
    EN: "Failed to create work order.",
  },
  "delete-work-order-success": {
    EN: "Work order deleted successfully",
  },
  "delete-work-order-failure": {
    EN: "Failed to delete work order",
  },
  "create-inspection-success": {
    EN: "Daily inspection created successfully",
  },
  "create-inspection-failure": {
    EN: "Failed to create daily inspection",
  },
  "update-inspection-success": {
    EN: "Daily inspection updated successfully",
  },
  "update-inspection-failure": {
    EN: "Failed to update daily inspection",
  },
  "delete-inspection-success": {
    EN: "Daily inspection deleted successfully",
  },
  "delete-inspection-failure": {
    EN: "Failed to delete daily inspection",
  },
  "update-vehicle-success": {
    EN: "Vehicle updated successfully",
  },
  "update-vehicle-failure": {
    EN: "Failed to update vehicle",
  },
  "delete-vehicle-success": {
    EN: "Vehicle deleted successfully",
  },
  "delete-vehicle-failure": {
    EN: "Failed to delete vehicle",
  },
};
